import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { LoggerService } from "../services/logger.service";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);

  return next(req).pipe(
    catchError((error) => {
      let errorMessage = "An unknown error occurred";

      if (error.error instanceof ErrorEvent) {
        // Client-side error
        errorMessage = `Client Error: ${error.error.message}`;
      } else {
        // Server-side error
        errorMessage = `Server Error (${error.status}): ${error.message}`;
      }

      logger.error("HTTP Error:", errorMessage, error);
      return throwError(() => error);
    }),
  );
};
